import i18n from "../../entrypoints/i18n";

class SubmissionTranslator {
  constructor(submissionType) {
    this.submissionType = submissionType;
  }

  getTitle = (fieldName) => {
    return i18n.t(`${this.submissionType}.${fieldName}.title`, { ns: "submissions" });
  };

  getLabel = (fieldName) => {
    return i18n.t(`${this.submissionType}.${fieldName}.label`, { ns: "submissions" });
  };

  getDescription = (fieldName) => {
    return i18n.t(`${this.submissionType}.${fieldName}.description`, { ns: "submissions" });
  };

  getError = (errorKey, params = {}) => {
    return i18n.t(`errors.${errorKey}`, { ns: "submissions", ...params });
  };

  getIssueTitle = (issueKey) => {
    return i18n.t(`issues.${issueKey}.title`, { ns: "submissions" });
  };

  getIssueDescription = (issueKey) => {
    return i18n.t(`issues.${issueKey}.description`, { ns: "submissions" });
  };
}

export default SubmissionTranslator;
